module.exports = __webpack_public_path__ + "img/14ry_tp03.a731b09f.jpg";